export default "__VITE_ASSET__bcc02c82__"